module.exports = __webpack_public_path__ + "static/media/sample_invoice_upload.51ce75bb.csv";